import {getFormattedMessage} from './validations';
const iterateObj = (obj) => {
    const res = {};
    if (obj.hasOwnProperty('id')) {
        for (let key in obj) {
            if (key !== 'id') {
                res[key + obj.id] = getFormattedMessage(obj[key].linguaKey, obj[key].defaultMessage);
            }
        }
    }
    return res;
};

const transformGiftCardFormError = (serverErrorObject) => {
    let errorObj = (({firstName, lastName, email, genericError}) => ({firstName, lastName, email, genericError}))(serverErrorObject);
    if (serverErrorObject.phone) {
        errorObj.phone = serverErrorObject.phone.phoneNumber;
    }
    if (serverErrorObject.giftCards) {
        serverErrorObject.giftCards.forEach((gfErrorObj) => {
            errorObj = {...errorObj, ...iterateObj(gfErrorObj)};
        });
    }
    return errorObj;
};
export default transformGiftCardFormError;
